/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  let productId = document.querySelector('.product-variant-id');
  let productJSON = document.querySelector('[data-productjson]');
  let productFormWrapper = document.querySelector('[data-form-wrapper]');
  let productStockCount = document.querySelector('[data-productstock-remaining-json]');
  let productStockHolder = document.querySelector('[data-productstock-count]');
  let threshold = document.querySelector('.cc__stockcounts[data-threshold]');
  let ccStock = document.querySelector('.cc__stockcounts');



  if( productId || productJSON || productStockCount){
    productId.addEventListener('change', et=>{
      let pJSON = JSON.parse(productJSON.innerHTML);
      let currentID = et.currentTarget.value;

      const productInfo = pJSON.filter(i=>{
        return i.id == currentID;
      });
      
      if( !productInfo[0].available){
        productFormWrapper.classList.add('variant--soldout');
      } else {
        productFormWrapper.classList.remove('variant--soldout');
      }

      if( productStockCount && productStockHolder){
        let stockJSON = JSON.parse(productStockCount.innerHTML);
        const remaining = stockJSON[currentID];

        productStockHolder.textContent = remaining;

        if( remaining == 'unavailable' ){
          ccStock.classList.remove('cc__hidebadgeinfo');
          ccStock.classList.add('cc__showbadgeinfo');
          return;
        }

        if( remaining < threshold.dataset.threshold){
          ccStock.classList.add('cc__hidebadgeinfo');
          ccStock.classList.remove('cc__showbadgeinfo');
        } else{
          ccStock.classList.remove('cc__hidebadgeinfo');
          ccStock.classList.add('cc__showbadgeinfo');
        }
      }
    });
  }


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
